import React from 'react';
import { Button, Card, Col, Row } from 'react-bootstrap';
import { useHistory } from "react-router-dom";
import Organization from './OrganizationForm';
import ThemePreview from './ThemePreview';
import { OrganizationProvider, useOrganization } from './context/OrganizationContext';
import { CardContainer } from '../widgets';

import "../../../assets/scss/organization.scss";
import { useSelector } from 'react-redux';

const OrganizationConfig = () => {
    const history = useHistory();
    const farmId = useSelector(state => state.farm.currentFarm.farm_uuid);

    const { isRequesting, isUpdateRequesting, handleOrganizationSave, handleReset } = useOrganization();

    return isRequesting ? null : (
        <CardContainer className="form-container org-form" lg={12} md={12}>
            <Card className="card-form">
                <Card.Header>
                    <Card.Title >
                        <Row>
                            <Col>
                                <i className="icon icon-theme" aria-hidden="true"></i>
                                <span className="ml-2">Organization Configuration</span>
                            </Col>

                            <Col>
                                <Button
                                    className='btn btn-sm float-right'
                                    variant='danger'
                                    onClick={() => {
                                        const url = `/home/farm/${farmId}/map`;
                                        history.push(url);
                                    }}>
                                    <i className='fa fa-times-circle mr-1' />
                                    Cancel
                                </Button>
                            </Col>
                        </Row>
                    </Card.Title>
                </Card.Header>
                <Card.Body className="org-card-body">
                    <ThemePreview />
                    <Organization />
                </Card.Body>
                <Card.Footer>
                    <Row>
                        <Col lg={4} md={4} sm={12} xs={12}>
                            <Button size="sm" className="float-right" disabled={isUpdateRequesting} onClick={handleOrganizationSave}>
                                <i className="fa fa-floppy-o mr-1"></i> {isUpdateRequesting ? <>Saving...</> : <>Save</>}
                            </Button>
                            <Button size="sm" variant="secondary" className="float-right mr-3" disabled={isUpdateRequesting} onClick={handleReset} >
                                <i className="fa fa-refresh mr-1" /> Reset
                            </Button>
                        </Col>
                    </Row>
                </Card.Footer>
            </Card>
        </CardContainer>
    )
}

export default (props) => (
    <OrganizationProvider>
        <OrganizationConfig {...props} />
    </OrganizationProvider>
);
